import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, query, orderBy, limit } from "firebase/firestore";
import { db } from "../App";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Modal, Form } from "react-bootstrap";

const PreventiveMaintenance = () => {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState({
    taskName: "",
    assetName: "",
    frequency: "",
    assignedTo: "",
    lastCompleted: "",
    nextDue: "",
    priority: "",
    notes: "",
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchTasks = async () => {
      const querySnapshot = await getDocs(collection(db, "preventive_maintenance"));
      const tasksList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setTasks(tasksList);
    };
    fetchTasks();
  }, []);

  const generateTaskID = async () => {
    const taskQuery = query(collection(db, "preventive_maintenance"), orderBy("taskID", "desc"), limit(1));
    const querySnapshot = await getDocs(taskQuery);
    if (!querySnapshot.empty) {
      const lastID = querySnapshot.docs[0].data().taskID;
      const newID = parseInt(lastID, 10) + 1;
      return newID.toString().padStart(5, "0");
    } else {
      return "00001";
    }
  };

  const handleAddTask = async () => {
    try {
      const newID = await generateTaskID();
      const taskToAdd = { ...newTask, taskID: newID };
      await addDoc(collection(db, "preventive_maintenance"), taskToAdd);
      setTasks([...tasks, taskToAdd]);
      setNewTask({
        taskName: "",
        assetName: "",
        frequency: "",
        assignedTo: "",
        lastCompleted: "",
        nextDue: "",
        priority: "",
        notes: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("Error adding task: ", error);
    }
  };

  const columns = [
    { field: "taskID", headerName: "Task ID", width: 120 },
    { field: "taskName", headerName: "Task Name", width: 200 },
    { field: "assetName", headerName: "Asset Name", width: 150 },
    { field: "frequency", headerName: "Frequency", width: 150 },
    { field: "assignedTo", headerName: "Assigned To", width: 150 },
    { field: "lastCompleted", headerName: "Last Completed", width: 150 },
    { field: "nextDue", headerName: "Next Due", width: 150 },
    { field: "priority", headerName: "Priority", width: 150 },
    { field: "notes", headerName: "Notes", width: 250 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <h2>Preventive Maintenance</h2>
      
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className="mb-2"
      >
        Add New Task
      </Button>

      <div style={{ height: 350, width: 1150 }}>
        <DataGrid
        getRowId={(row) => row.taskName}
          rows={tasks}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          style={{ backgroundColor: "white" }}
        />
      </div>

      

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Task Name</Form.Label>
              <Form.Control
                type="text"
                value={newTask.taskName}
                onChange={(e) => setNewTask({ ...newTask, taskName: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Asset Name</Form.Label>
              <Form.Control
                type="text"
                value={newTask.assetName}
                onChange={(e) => setNewTask({ ...newTask, assetName: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Frequency</Form.Label>
              <Form.Control
                type="text"
                value={newTask.frequency}
                onChange={(e) => setNewTask({ ...newTask, frequency: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Assigned To</Form.Label>
              <Form.Control
                type="text"
                value={newTask.assignedTo}
                onChange={(e) => setNewTask({ ...newTask, assignedTo: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Last Completed</Form.Label>
              <Form.Control
                type="date"
                value={newTask.lastCompleted}
                onChange={(e) => setNewTask({ ...newTask, lastCompleted: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Next Due</Form.Label>
              <Form.Control
                type="date"
                value={newTask.nextDue}
                onChange={(e) => setNewTask({ ...newTask, nextDue: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Priority</Form.Label>
              <Form.Control
                type="text"
                value={newTask.priority}
                onChange={(e) => setNewTask({ ...newTask, priority: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newTask.notes}
                onChange={(e) => setNewTask({ ...newTask, notes: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddTask}>
            Save Task
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PreventiveMaintenance;
